export default {"src":"/_next/static/media/sort_downward.78733ba6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};